import * as types from './mutation-types'

export default {
  [types.SET_PAGE_TITLE] (state, title) {
    state.pageTitle = title
  },
  [types.SET_PAGE_DESC] (state, desc) {
    state.pageDesc = desc
  },  
  [types.SET_PAGE_LANG] (state, lang) {
    state.pageLang = lang
  },  
  [types.SET_SPLASH_MODE] (state, mode) {
    if (state.splashPage !== mode) {
      state.splashPage = mode
    }
  },
  [types.SHOW_MENU] (state) {
    state.menuVisible = true
  },
  [types.HIDE_MENU] (state) {
    state.menuVisible = false
  },
  [types.CHANGE_THEME] (state, theme) {
    state.theme = theme
  },
  [types.CHANGE_STORE] (state, store) {
    state.store = store
    localStorage.rma_store = store
  },
  [types.CHANGE_COUNTRY] (state, country) {
    state.country = country
  },
  [types.CHANGE_STEP] (state, step) {
    state.step = step
    localStorage.rma_step = step
  },
  [types.SELECT_PRODUCT] (state, products) {
    state.prodList = products
  },
  [types.SELECT_ORDER_COUNT] (state, count) {
    state.orderSelectedCount = count
  },
  [types.SELECT_RETAIL_COUNT] (state, count) {
    state.retailSelectedCount = count
  },
  [types.SHOW_LOADING](state) {
    state.pageLoading = true
  },
  [types.HIDE_LOADING](state) {
    state.pageLoading = false
  },
  [types.SHOW_DROP_MENU](state) {
    state.dropMenuVisible = true
  },
  [types.HIDE_DROP_MENU](state) {
    state.dropMenuVisible = false
  },
  [types.CHANGE_DROP_MENU](state, menu) {
    state.dropMenu = menu
  },
  [types.CHANGE_FAULT_INFO](state, info) {
    state.productFaultInfo = info
  },
  [types.CHANGE_FAULT_MSG](state, info) {
 //   window.console.log(info)
    if (info && info.field && info.value)
      state.productFaultInfo[info.field] = info.value
  }  
}
